import { Component, OnInit, Output } from '@angular/core';
import { Orgstyle } from '../../pages/orgaccount/orgstyle/model/orgstyle';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Customer } from '@src/app/models/customer';


import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customerportal-control',
  templateUrl: './customerportal-control.component.html',
  styleUrls: ['./customerportal-control.component.css']
})
export class CustomerportalControlComponent implements OnInit {
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  @Output() orgstyle:Orgstyle;
  customer:Customer = JSON.parse(SessionHelper.getCustomer());
  userId:string = SessionHelper.getUserSub();

  constructor() { }

  ngOnInit() {
    //this.favIcon.href = ' https://www.connectmyapps.com/img/CMA_Favicon_16.ico ' ;
      this.orgstyle = new Orgstyle;
      this.orgstyle.sidenav = 'top';
      if(SessionHelper.getDynamicStyle() && SessionHelper.getDynamicStyle() !== 'undefined' ){
        
        this.orgstyle = JSON.parse(SessionHelper.getDynamicStyle());
      } 
  }

  // toggleCMAFavIcon(){
  //   //Place into ngOnInit to replace fav icon on customerportal
  //   this.favIcon.href = ' https://www.connectmyapps.com/img/CMA_Favicon_16.ico ' ;
  // }

  // toggleTalenTechFavicon(){
  //   this.favIcon.href = 'https://talentech.com/wp-content/uploads/2020/07/cropped-favicon-192x192.png';
  // }
 


}
